export var NissanVehicleStatus;
(function (NissanVehicleStatus) {
    NissanVehicleStatus[NissanVehicleStatus["Available"] = 1] = "Available";
    NissanVehicleStatus[NissanVehicleStatus["Processed"] = 2] = "Processed";
    NissanVehicleStatus[NissanVehicleStatus["ShippedManually"] = 3] = "ShippedManually";
    NissanVehicleStatus[NissanVehicleStatus["ExceptionDriverRemoved"] = 4] = "ExceptionDriverRemoved";
    NissanVehicleStatus[NissanVehicleStatus["Delivered"] = 5] = "Delivered";
    NissanVehicleStatus[NissanVehicleStatus["Archived"] = 6] = "Archived";
})(NissanVehicleStatus || (NissanVehicleStatus = {}));
export var NissanVehicleProcessStatus;
(function (NissanVehicleProcessStatus) {
    NissanVehicleProcessStatus[NissanVehicleProcessStatus["Success"] = 1] = "Success";
    NissanVehicleProcessStatus[NissanVehicleProcessStatus["Incomplete"] = 2] = "Incomplete";
    NissanVehicleProcessStatus[NissanVehicleProcessStatus["Failed"] = 3] = "Failed";
})(NissanVehicleProcessStatus || (NissanVehicleProcessStatus = {}));
